import { Form } from 'react-bootstrap';

const PasswordField = ({ labelText, placeholder, inputValue, onChange}) => {
    return (
        <Form.Group className="mb-2" controlId="password">
          <Form.Label>{labelText}</Form.Label>
          <Form.Control
            type="password"
            value={inputValue}
            placeholder={placeholder}
            onChange={onChange}
            required
          />
        </Form.Group>
    )
}

export default PasswordField